import Styles from './Styles';

export default class Dom {
  $ = null;
  Styles = null;

  constructor() {
    this.Styles = new Styles(this);
  }

  async init() {
    // Pass...
  }

  use($) {
    this.$ = $;
  }


}



// WEBPACK FOOTER //
// ./src/Dom/Dom.js